import * as React from 'react';
import { Badge, BadgeProps } from 'ui/badge/badge';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';

interface FactBadgeProps {
  badgeProps: BadgeProps;
  section?: number;
  [key: string]: any;
}

export const ResidualRiskFactItem = (props: FactBadgeProps) => {
  const { riskAreaRest, riskTrendRest, riskWeightRest, url, title, hideRiskWeight, linkDomain, portalTarget } = props;

  const residualRiskProps = {
    title: riskAreaRest ? title : undefined,
    tooltip: riskAreaRest?.description,
    text: !hideRiskWeight ? riskWeightRest : '',
    filled: false,
    backgroundColor: (riskAreaRest?.value && riskAreaRest?.backgroundColor) ? riskAreaRest.backgroundColor : undefined,
    riskTrend: { value: riskTrendRest?.[0]?.value, description: riskTrendRest?.[0]?.description, icon: riskTrendRest?.[0]?.icon }
  };
  if (!riskWeightRest) {
    return null;
  }
  return (
    <FactLink id={props.componentId} classNames="fact-item" section={linkDomain} url={url}>
      <Badge
        {...residualRiskProps}
        portalTarget={portalTarget}
      />
    </FactLink>
  );
};
